import * as yup from 'yup';
import { isValidPhoneNumber } from 'react-phone-number-input';

const giftValidation = yup.object().shape({
  name: yup.string().required(),
  giftNotes: yup.string().optional(),
  phoneNumber: yup.lazy(value => {
    if (value) {
      return yup.string().test('invalid', 'inValidPhoneNumber', number => isValidPhoneNumber(number));
    }
    return yup.string().required();
  }),
});

export default giftValidation;
